export type FileIsFor = 'INCIDENT' | 'INVESTIGATION' | 'REVIEW' | 'ACTION';

export const FileIsFor = {
  INCIDENT: 'INCIDENT' as FileIsFor,
  INVESTIGATION: 'INVESTIGATION' as FileIsFor,
  REVIEW: 'REVIEW' as FileIsFor,
  ACTION: 'ACTION' as FileIsFor,
};
